import { render, staticRenderFns } from "./CheckRenameComponentDialog.vue?vue&type=template&id=5f26f1a2&scoped=true"
import script from "./CheckRenameComponentDialog.vue?vue&type=script&lang=js"
export * from "./CheckRenameComponentDialog.vue?vue&type=script&lang=js"
import style0 from "./CheckRenameComponentDialog.vue?vue&type=style&index=0&id=5f26f1a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26f1a2",
  null
  
)

export default component.exports